import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders,HttpResponse } from "@angular/common/http";

import { of, Subscription } from "rxjs";
import { Observable } from "rxjs";
import { Subject } from "rxjs";




import { EventCounterList, EventCounter } from "./data.model";
import { DashboardConfigManager } from '../../services/dashboard.config.service';
import { AuthService } from '../../services/auth.service';
import { WsiUtilityService } from '../../services/wsi.helper.service';
import { HubConnection, HubProxy, SignalRService, SubscriptionWsi, SubscriptionDeleteWsi, Link } from '../../signalr/index';
import { LogService } from "../../logger/loggerProvider/loggerhelper.service";
import { catchError, map } from "rxjs/operators";
const eventCountersUrl: string = "/api/eventcounters/";
const eventCountersSubscriptionUrl: string = "/api/sr/eventcounterssubscriptions/";

/**
 * EventCounterService service.
 * Provides the functionality to read events from WSI.
 *
 * @export
 * @class EventCounterService
 */
@Injectable()
export class EventCounterService {
    public hubProxy: HubProxy<EventCounterList>;
    public isSubscribed: boolean = false;
    public constructor(private authService: AuthService,
        private wsiHelper: WsiUtilityService,
        private http: HttpClient,
        private dashboardConfig: DashboardConfigManager,
        private loggerHelper: LogService,
        private _signalRService: SignalRService) {
        this.createConnection();
        this.hubProxy.hubConnection.connected.subscribe(value => this.onSignalRConnection(value), error => this.onSignalRConnectionError(error));
    }

    /**
   * Gets all event counters for all categories of the system.
   *
   * @returns {Observable<EventCounterList>}
   *
   * @memberOf EventCounterService
   */
    public getEventCountersAll(): Observable<EventCounterList> {

        let headers: HttpHeaders = this.wsiHelper.httpGetDefaultHeader(this.authService.getToken());
        let url: string = this.dashboardConfig.getBaseUrl() + eventCountersUrl;

        return this.http.get(url, { headers: headers })
            .pipe(map(response => this.wsiHelper.extractData(response as any, EventCounterService.name, "getEventCountersAll()"))
            ,catchError(response => this.wsiHelper.handleError(response, EventCounterService.name, "getEventCountersAll()")));
    }

    /**
     * Gets the event counters for the specified category Id
     *
     * @param {number} categoryId
     * @returns {Observable<EventCounter>}
     *
     * @memberOf EventCounterService
     */
    public getEventCounters(categoryId: number): Observable<EventCounter> {

        let headers: HttpHeaders = this.wsiHelper.httpGetDefaultHeader(this.authService.getToken());
        let url: string = this.dashboardConfig.getBaseUrl() + eventCountersUrl;
        if (categoryId != undefined) {
            url += categoryId.toString();
        }

        return this.http.get(url, { headers: headers })
            .pipe(map(response => this.wsiHelper.extractData(response as any, EventCounterService.name, "getEventCounters()")),
            catchError(response => this.wsiHelper.handleError(response, EventCounterService.name, "getEventCounters()")));
    }

    /**
     * Subscribes for all event counters of the system.
     *
     * @returns {Observable<void>}
     *
     * @memberOf EventCounterService
     */
    public subscribeEventCounters(): Observable<boolean> {

        let headers: HttpHeaders = this.wsiHelper.httpPostDefaultHeader(this.authService.getToken());
        let httpPostProxy: Subject<boolean> = new Subject<boolean>();
        //If Already Subscribed, just update the Observable with last value.
        if (this.isSubscribed) {
            this.loggerHelper.logInfo(EventCounterService.name + ":subscribeEventCounters", "Already Subscribed, reponding with last value");
        //TODO:this.hubProxy.events.publishReplay();
            return of();
        }
        else {
            this.isSubscribed = true;
            if (this.hubProxy.hubConnection.isConnected === false) {
                let connectedSubscription: Subscription = this.hubProxy.hubConnection.connected.subscribe(started => {
                    if (started === true) {
                        this.loggerHelper.logInfo(EventCounterService.name + ":subscribeEventCounters", "Subscription successful.");
                        // connection ID is available now, we can setup the 'post observable' now and not earlier
                        if (connectedSubscription !== undefined) {
                            connectedSubscription.unsubscribe();
                        }
                        else {
                            this.loggerHelper.logError(EventCounterService.name + ":subscribeEventCounters", "Error while creating subscription.");
                        }
                        let url: string = this.dashboardConfig.getBaseUrl() + (eventCountersSubscriptionUrl + this.hubProxy.connectionId);
                        let httpPost: Observable<boolean> = this.http.post(url, {}, { headers: headers }).pipe(map(response => this.extractData(response as any, EventCounterService.name, "subscribeEventCounters()")),
                           /* .map(response => this.extractData(response as any, EventCounterService.name, "subscribeEventCounters()"))*/
                            catchError(response => this.wsiHelper.handleError(response, EventCounterService.name, "subscribeEventCounters()")));
                        httpPost.subscribe(value => this.onSubscribeEventCountersNext(value, httpPostProxy),
                            error => this.onSubscribeEventCountersError(error, httpPostProxy));
                    }
                });
                this.hubProxy.hubConnection.startHubConnection();
            }
            else {
                this.loggerHelper.logInfo(EventCounterService.name + ":subscribeEventCounters", "Subscription successful.");
                this.isSubscribed = true;
                let url: string = this.dashboardConfig.getBaseUrl() + (eventCountersSubscriptionUrl + this.hubProxy.connectionId);
                let httpPost: Observable<boolean> = this.http.post(url, {}, { headers: headers })
                    .pipe(map(response => this.extractData(response as any, EventCounterService.name, "subscribeEventCounters()"))
                    ,catchError(response => this.wsiHelper.handleError(response, EventCounterService.name, "subscribeEventCounters()")));
                httpPost.subscribe(value => this.onSubscribeEventCountersNext(value, httpPostProxy),
                    error => this.onSubscribeEventCountersError(error, httpPostProxy));
            }
        }
        return httpPostProxy.asObservable();
    }

    /**
     * Event for the event counter notifications.
     *
     * @returns {Observable<EventCounterList>}
     *
     * @memberOf EventCounterService
     */
    public eventCountersNotification(): Observable<EventCounterList> {
        return this.hubProxy.events;
    }

    public unSubscribeEventCounters(): Observable<boolean> {
        let headers: HttpHeaders = this.wsiHelper.httpDeleteDefaultHeader(this.authService.getToken());
        let httpPostProxy: Subject<boolean> = new Subject<boolean>();

        if (this.hubProxy.hubConnection.isConnected === false) {

            let connectedSubscription: Subscription = this.hubProxy.hubConnection.connected.subscribe(started => {
                this.loggerHelper.logInfo(EventCounterService.name + ":unSubscribeEventCounters", "Unsubscribed succesfully called.");
                this.isSubscribed = false;
                if (started === true) {
                    // connection ID is available now, we can setup the 'post observable' now and not earlier
                    if (connectedSubscription !== undefined) {
                        connectedSubscription.unsubscribe();
                    }
                    else {
                        this.loggerHelper.logError(EventCounterService.name + ":unSubscribeEventCounters", "Error while removing subscription.");
                    }
                    let url: string = this.dashboardConfig.getBaseUrl() + (eventCountersSubscriptionUrl + this.hubProxy.connectionId);
                    let httpPost: Observable<boolean> = this.http.delete(url, { headers: headers })
                        .pipe(map(response => this.extractData(response as any, EventCounterService.name, "unSubscribeEventCounters()"))
                        ,catchError(response => this.wsiHelper.handleError(response, EventCounterService.name, "unSubscribeEventCounters()")));
                    httpPost.subscribe(value => this.onUnsubscribeEventCountersNext(value, httpPostProxy),
                        error => this.onUnsubscribeEventCountersError(error, httpPostProxy));
                }
            });
            this.hubProxy.hubConnection.startHubConnection();
        }
        else {
            this.loggerHelper.logInfo(EventCounterService.name + ":unSubscribeEventCounters", "Unsubscribed succesfully called.");
            this.isSubscribed = false;
            let url: string = this.dashboardConfig.getBaseUrl() + (eventCountersSubscriptionUrl + this.hubProxy.connectionId);
            let httpPost: Observable<boolean> = this.http.delete(url, { headers: headers })
                .pipe(map(response => this.extractData(response as any, EventCounterService.name, "unSubscribeEventCounters()"))
                ,catchError(response => this.wsiHelper.handleError(response, EventCounterService.name, "unSubscribeEventCounters()")));
            httpPost.subscribe(value => this.onUnsubscribeEventCountersNext(value, httpPostProxy),
                error => this.onUnsubscribeEventCountersError(error, httpPostProxy));
        }
        return httpPostProxy.asObservable();
    }

    private extractData(res: Response, traceModule: string, method: string): boolean {
        if (res.status < 200 || res.status >= 300) {
            throw new Error("Bad response status: " + res.status);
        }
        try {
            if (res.status === 200) {

                return true;
            }
            else {

                return false;
            }
        }
        catch (exc) {
            return false;
        }
    }

    private onSubscribeEventCountersNext(value: boolean, httpPostProxy: Subject<boolean>): void {
        httpPostProxy.next(value);
        httpPostProxy.complete();
    }

    private onSubscribeEventCountersError(error: any, httpPostProxy: Subject<boolean>): void {
        this.loggerHelper.logError(EventCounterService.name + ":onSubscribeEventCountersError", "Error on subscription.");
        httpPostProxy.error(error);
    }

    private onUnsubscribeEventCountersNext(value: boolean, httpPostProxy: Subject<boolean>): void {
        httpPostProxy.next(value);
        httpPostProxy.complete();
    }

    private onUnsubscribeEventCountersError(error: any, httpPostProxy: Subject<boolean>): void {
        this.loggerHelper.logError(EventCounterService.name + ":onUnsubscribeEventCountersError", "Error in un-subscribing.");
        httpPostProxy.error(error);
    }

    private createConnection(): void {
        let hubConnection: HubConnection = this._signalRService.createHubConnection(this.dashboardConfig.getBaseUrl() + ("/signalr"), EventCounterService.name);
        this.hubProxy = new HubProxy<EventCounterList>(hubConnection, "eventCountersHub", "notifyEventCounters", EventCounterService.name);
    }

    private onSignalRConnectionError(error: any): void {
        this.loggerHelper.logError(EventCounterService.name + ":onSignalRConnectionError", "Error in un-subscribing.");
    }

    private onSignalRConnection(value: boolean): void {
        this.loggerHelper.logInfo(EventCounterService.name + ":onSignalRConnection", "Connection is successfull.");
    }
}
